/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("unused", "MemberVisibilityCanBePrivate", "EXPERIMENTAL_API_USAGE")

package features.userTransactionHistory.internal

import features.userTransactionHistory.models.UserTransactionHistoryModel
import kangaroorewards.appsdk.core.domain.Result
import kangaroorewards.appsdk.core.domain.AsyncUseCase
import features.userTransactionHistory.internal.UserTransactionHistoryUseCase.Params

internal class UserTransactionHistoryUseCase : AsyncUseCase<UserTransactionHistoryModel, Params>() {

    internal class Params(
       val overrideHeaders : Map<String, String>? = null,

    )

    private val userTransactionHistoryService: UserTransactionHistoryService = UserTransactionHistoryServiceImpl()

    override suspend fun run(params: Params): Result<UserTransactionHistoryModel> {
        return userTransactionHistoryService.getUserTransactionHistory(
            overrideHeaders = params.overrideHeaders,

        )
    }
}
